import { render, staticRenderFns } from "./Lawyer.vue?vue&type=template&id=4a1ef582"
import script from "./Lawyer.vue?vue&type=script&lang=js"
export * from "./Lawyer.vue?vue&type=script&lang=js"
import style0 from "./Lawyer.vue?vue&type=style&index=0&id=4a1ef582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports